<script setup>
import { RouterView, useRoute } from 'vue-router';
import Panel from 'primevue/panel';
const route = useRoute();
</script>

<template>
	<div class="signin-container">
		<Panel class="signin-panel">
			<template #header>
				<div class="logo signin-header-logo"></div>
				<span class="headline mt-2">{{ route.meta.headline }}</span>
			</template>
			<router-view></router-view>
		</Panel>
	</div>
</template>

<style>
.signin-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

@media only screen and (max-width: 768px) {
	.signin-panel {
		width: 65%;
	}
}

@media only screen and (min-width: 769px) and (max-width: 1200px) {
	.signin-panel {
		width: 50%;
	}
}

@media only screen and (min-width: 1200px) {
	.signin-panel {
		width: 30%;
	}
}

.signin-panel .p-panel-content .login-small-form {
	min-height: 11.75rem;
}

.signin-panel .p-panel-content .login-large-form {
	min-height: 23.75rem;
}

.signin-panel .p-panel-header {
	justify-content: center;
	flex-direction: column;
	font-size: 1.5rem;
	font-weight: 600;
	padding-bottom: 0rem !important;
}

.signin-panel .p-panel-header .signin-header-logo {
	height: 50px;
	width: 100%;
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}
</style>
